import {THTMLFormElements} from "data/types/validators";

export abstract class AbstractValidator<T = unknown> {
	abstract validate(formControl: THTMLFormElements, ...args: T[]): boolean;
	abstract getErrorMessage(): string;
}
